import { render, staticRenderFns } from "./ModalReviewCreate.vue?vue&type=template&id=c59f3f5e"
import script from "./ModalReviewCreate.vue?vue&type=script&lang=js"
export * from "./ModalReviewCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports